"use strict";

exports.__esModule = true;
exports.init = exports.getUsersAndGroups = exports.getUserLoginCount = exports.getUsedUserLicenses = exports.getUsedDownloadTraffic = exports.getSingleEvents = exports.getAnalyticsEvents = void 0;
var _index = require("../../../swcp-base/js/helpers/index");
var _WebRequestHelper = require("../../../swcp-base/js/helpers/WebRequestHelper");
var _actionTypes = require("./actionTypes");
var _v = _interopRequireDefault(require("uuid/v4"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const init = data => {
  data.widgets.map(widget => {
    widget.id = (0, _v.default)();
  });
  return dispatch => {
    dispatch({
      type: _actionTypes.INIT_ANALYTICS,
      data: data
    });
  };
};
exports.init = init;
const getUsedDownloadTraffic = (widgetId, useAuthentication = true) => {
  let params = {
    metric: "aws-s3",
    dimension: "current-download-traffic",
    startDate: "startOfMonth"
  };
  return function (dispatch) {
    const parsed = (0, _index.parseParamShorthands)(params);
    return (0, _WebRequestHelper.createRequest)(useAuthentication).then(request => {
      request.method = "get";
      request.url = `/analytics/custom${(0, _index.paramsToString)(parsed)}`;
      return (0, _WebRequestHelper.sendRequest)(request).then(response => {
        let numberToCountToUnit = "GB";
        let inputUnit = "Byte";
        let decimalCharacter = ".";
        let numberOfDecimalPlaces = 2;
        let displayedEndString = " / 1000 GB";
        let dataObject = {
          numberToCountToUnit: numberToCountToUnit,
          inputUnit: inputUnit,
          decimalCharacter: decimalCharacter,
          numberOfDecimalPlaces: numberOfDecimalPlaces,
          displayedEndString: displayedEndString,
          numberToCountTo: (0, _index.formatFilesize)(response.data, inputUnit, numberToCountToUnit, numberOfDecimalPlaces)
        };
        dispatch({
          type: _actionTypes.GET_DATA_SUCCESS,
          widgetId: widgetId,
          data: dataObject,
          params: params
        });
      }).catch(error => {
        return dispatch({
          type: _actionTypes.GET_DATA_FAILURE,
          widgetId: widgetId,
          data: error.response ? {
            Message: error.response.data.Message
          } : {
            Message: "An error occurred."
          }
        });
      });
    }).catch(error => {
      return dispatch({
        type: _actionTypes.GET_DATA_FAILURE,
        widgetId: widgetId,
        data: error.response ? {
          Message: error.response.data.Message
        } : {
          Message: "An error occurred."
        }
      });
    });
  };
};
exports.getUsedDownloadTraffic = getUsedDownloadTraffic;
const getUsedUserLicenses = (widgetId, useAuthentication = true) => {
  let params = {
    metric: "user",
    dimension: "current-user-count"
  };
  return function (dispatch) {
    const parsed = (0, _index.parseParamShorthands)(params);
    return (0, _WebRequestHelper.createRequest)(useAuthentication).then(request => {
      request.method = "get";
      request.url = `/analytics/custom${(0, _index.paramsToString)(parsed)}`;
      return (0, _WebRequestHelper.sendRequest)(request).then(response => {
        let displayedEndString = " / 1000";
        let dataObject = {
          displayedEndString: displayedEndString,
          numberToCountTo: response.data
        };
        dispatch({
          type: _actionTypes.GET_DATA_SUCCESS,
          widgetId: widgetId,
          data: dataObject,
          params: params
        });
      }).catch(error => {
        return dispatch({
          type: _actionTypes.GET_DATA_FAILURE,
          widgetId: widgetId,
          data: error.response ? {
            Message: error.response.data.Message
          } : {
            Message: "An error occurred."
          }
        });
      });
    }).catch(error => {
      return dispatch({
        type: _actionTypes.GET_DATA_FAILURE,
        widgetId: widgetId,
        data: error.response ? {
          Message: error.response.data.Message
        } : {
          Message: "An error occurred."
        }
      });
    });
  };
};
exports.getUsedUserLicenses = getUsedUserLicenses;
const getUserLoginCount = (widgetId, params, useAuthentication = true) => {
  return function (dispatch) {
    return (0, _WebRequestHelper.createRequest)(useAuthentication).then(request => {
      params.metric = "user";
      params.dimension = "login";
      let endpoint = "/analytics/data";
      let skip = 0;
      let take = 2000000;
      return (0, _WebRequestHelper.getFullList)(request, endpoint, params, skip, take).then(response => {
        let displayedEndString = " users";
        let dataObject = {
          numberToCountTo: response.data.length,
          displayedEndString: displayedEndString
        };
        dispatch({
          type: _actionTypes.GET_DATA_SUCCESS,
          widgetId: widgetId,
          data: dataObject
        });
      }).catch(error => {
        return dispatch({
          type: _actionTypes.GET_DATA_FAILURE,
          widgetId: widgetId,
          data: error.response ? {
            Message: error.response.data.Message
          } : {
            Message: "An error occurred."
          }
        });
      });
    }).catch(error => {
      return dispatch({
        type: _actionTypes.GET_DATA_FAILURE,
        widgetId: widgetId,
        data: error.response ? {
          Message: error.response.data.Message
        } : {
          Message: "An error occurred."
        }
      });
    });
  };
};
exports.getUserLoginCount = getUserLoginCount;
const getUsersAndGroups = (widgetId, useAuthentication = true) => {
  return dispatch => {
    dispatch({
      type: _actionTypes.GET_DATA_REQUEST,
      widgetId: widgetId
    });
    return (0, _WebRequestHelper.createRequest)(useAuthentication).then(request => {
      let endpoint = "/users";
      let take = 200;
      let queryParams = {};
      return (0, _WebRequestHelper.getFullList)(request, endpoint, queryParams, 0, take).then(response => {
        let file_name = (0, _index.getTodayDate)("YYYY-MM-DD");
        response.mime_type = "application/json";
        response.file_name = `User Data ${file_name}.json`;
        dispatch({
          type: _actionTypes.GET_DATA_SUCCESS,
          widgetId: widgetId,
          data: response.data
        });
        return response;
      }).catch(error => {
        return dispatch({
          type: _actionTypes.GET_DATA_FAILURE,
          widgetId: widgetId,
          data: error.response ? {
            Message: error.response.data.Message
          } : {
            Message: "An error occurred."
          }
        });
      });
    }).catch(error => {
      return dispatch({
        type: _actionTypes.GET_DATA_FAILURE,
        widgetId: widgetId,
        data: error.response ? {
          Message: error.response.data.Message
        } : {
          Message: "An error occurred."
        }
      });
    });
  };
};
exports.getUsersAndGroups = getUsersAndGroups;
const getAnalyticsEvents = (widgetId, queryParams, useAuthentication = true) => {
  return dispatch => {
    dispatch({
      type: _actionTypes.GET_DATA_REQUEST,
      widgetId: widgetId
    });
    return new Promise(resolve => {
      return (0, _WebRequestHelper.createRequest)(useAuthentication).then(request => {
        let parsedParams;
        let endpoint = "/analytics/custom";
        queryParams.metric = "analytics";
        queryParams.dimension = "overview";
        parsedParams = (0, _index.parseParamShorthands)(queryParams);
        request.method = "get";
        request.url = `${endpoint}${(0, _index.paramsToString)(parsedParams)}`;
        return (0, _WebRequestHelper.sendRequest)(request).then(analyticsOverviewResponse => {
          getSingleEvents(analyticsOverviewResponse, queryParams).then(analyticsOverviewResponse => {
            let file_name = (0, _index.formatDateToHuman)(queryParams.startDate, "YYYY-MM-DD") + " to " + (0, _index.formatDateToHuman)(queryParams.endDate, "YYYY-MM-DD");
            analyticsOverviewResponse.mime_type = "application/json";
            analyticsOverviewResponse.file_name = `VRL Analytics Data ${file_name}.json`;
            dispatch({
              type: _actionTypes.GET_DATA_SUCCESS,
              widgetId: widgetId,
              data: analyticsOverviewResponse.data
            });
            resolve(analyticsOverviewResponse);
          });
        }).catch(error => {
          return dispatch({
            type: _actionTypes.GET_DATA_FAILURE,
            widgetId: widgetId,
            data: error.response ? {
              Message: error.response.data.Message
            } : {
              Message: "An error occurred."
            }
          });
        });
      }).catch(error => {
        return dispatch({
          type: _actionTypes.GET_DATA_FAILURE,
          widgetId: widgetId,
          data: error.response ? {
            Message: error.response.data.Message
          } : {
            Message: "An error occurred."
          }
        });
      });
    });
  };
};
exports.getAnalyticsEvents = getAnalyticsEvents;
const getSingleEvents = (analyticsOverviewResponse, queryParams) => {
  if (analyticsOverviewResponse.data.length === 0) {
    return Promise.resolve(analyticsOverviewResponse);
  }
  return (0, _WebRequestHelper.createRequest)(true).then(request => {
    return new Promise(resolve => {
      let skip = 0;
      let take = 2000000;
      let accumulatedEntries = [];
      let count = 0;
      let endpoint = "/analytics/data";
      return analyticsOverviewResponse.data.reduce((promise, analyticsEntry) => {
        return promise.then(() => {
          queryParams.metric = analyticsEntry.metric;
          queryParams.dimension = analyticsEntry.dimension;
          return (0, _WebRequestHelper.getFullList)(request, endpoint, queryParams, skip, take).then(analyticsEntryResponse => {
            Array.prototype.push.apply(accumulatedEntries, analyticsEntryResponse.data);
            count++;
            if (analyticsOverviewResponse.data.length === count) {
              analyticsOverviewResponse.data = accumulatedEntries;
              resolve(analyticsOverviewResponse);
            }
          }).catch(error => {
            console.dir(error);
            throw error;
          });
        }).catch(error => {
          console.dir(error);
          throw error;
        });
      }, Promise.resolve());
    });
  });
};
exports.getSingleEvents = getSingleEvents;